
import { useCallback, useMemo } from "react";
import { formatDuration } from "@/utils/dataUtils/formatters";

export const useClipsFormatter = () => {
  const formatClipsCallback = useCallback((clips) => {
    console.log("Formatting clips, input:", clips);
    
    if (!clips || !Array.isArray(clips) || clips.length === 0) {
      console.log("No clips to format or invalid input");
      return [];
    }
    
    const formattedClips = clips.map(clip => {
      console.log("Processing clip:", clip);
      
      // Handle potential property name variations
      const id = clip.id;
      const title = clip.title || "";
      const thumbnailUrl = clip.thumbnail || clip.thumbnail_url || "";
      const duration = clip.duration || 0;
      const playlistName = clip.playlist_name || 
                         (clip.playlists ? clip.playlists.name : "") || 
                         "";
                         
      console.log("Formatted properties:", { id, title, playlistName, thumbnailUrl, duration });
                         
      return {
        id,
        title,
        playlistName,
        thumbnailUrl,
        duration // Keep as number for RelatedClips component
      };
    });
    
    console.log("Final formatted clips:", formattedClips);
    return formattedClips;
  }, []);

  return { formatClipsCallback };
};
